import { apiClient } from './authService';

// Devis clients — une feuille libre ; enregistrée en silence à l'impression /
// à l'envoi (trace + e-mail par le serveur). /api/devis/
const devisService = {
  // sheet: { customer_name, customer_phone, customer_email, remise, document,
  //          items: [{ product?, product_name, quantity, unit_price }] }
  saveDevis: async (id, sheet) => {
    const response = id
      ? await apiClient.put(`devis/${id}/`, sheet)
      : await apiClient.post('devis/', sheet);
    return response.data;
  },

  // { configured } — le serveur sait-il envoyer des e-mails (SMTP) ?
  getEmailStatus: async () => {
    const response = await apiClient.get('devis/email_status/');
    return response.data;
  },

  sendEmail: async (id, to) => {
    const response = await apiClient.post(`devis/${id}/send_email/`, { to });
    return response.data;
  },
};

export default devisService;
